import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import moment from 'moment';

import styles from './ArticleNoteSm.module.scss';

@injectIntl
export default class ArticleNoteSmComponent extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    news: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      publicationDate: props.publicationDate,
      background: props.background
    };
  }

  currentLanguage = LanguageService.getLang();

  renderCategories() {
    const { categoryPath } = this.props;
    const categories = _get(this.props, categoryPath);

    return categories.map((taxonomy, index) => {
      return (
        <span
          key={index}
          // Disabled: onClick={() => this.props.filter(taxonomy.codename)}
          className={styles.ArticleNoteMdCategoryValueOption}
        >
          {taxonomy.name}
        </span>
      );
    });
  }

  render() {
    const { className, messages, categorySlug } = this.props;
    const {
      title,
      publicationDate,
      photo: { url },
      slug
    } = this.props.news;
    const year = moment(publicationDate).format('YYYY');

    return (
      <div className={`${styles.ArticleNoteSm} ${className}`}>
        <Link to={`${categorySlug[this.currentLanguage]}/${year}/${slug}`}>
          <div
            className={styles.ContentImage}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                url
              )})`
            }}
          />
          <div className={styles.ContainerDetails}>
            <div className={styles.ContainerContactInfo}>
              <span className={styles.ProductNameSpan}>{title}</span>
              <span className={styles.DateSpan}>
                {moment(publicationDate).format('LL')}
              </span>
            </div>
          </div>
        </Link>
        <div className={styles.ArticleNoteSmCompanyInfo}>
          <span className={styles.ArticleNoteSmCategoryLabel}>
            {this.props.intl.formatMessage(messages.category)}
          </span>
          <span className={styles.ArticleNoteSmCategoryValue}>
            {this.renderCategories()}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArticlesPage/components/ArticleNoteSm/ArticleNoteSm.js